var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardTopbarNoticeIconNormal = function SvgNewcsDashboardTopbarNoticeIconNormal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_topbar_notice_icon_normal_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#707070",
    d: "M1943 326h22v22h-22z",
    "data-name": "\\u77E9\\u5F62 55"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_topbar_notice_icon_normal_svg__a)",
    transform: "translate(-1943 -326)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#393157",
    d: "M1945.651 340.079v-5.844a8.25 8.25 0 0 1 16.5 0v5.844l1.563 3.12a.823.823 0 0 1-.738 1.192h-18.15a.823.823 0 0 1-.738-1.192zm15.988 2.665-1.053-2.1a.8.8 0 0 1-.087-.368v-6.041a6.6 6.6 0 0 0-13.2 0v6.038a.8.8 0 0 1-.087.368l-1.053 2.1h15.479Zm-11.429 3.923a.824.824 0 1 1 1.055-1.266 4.13 4.13 0 0 0 5.27 0 .824.824 0 1 1 1.054 1.266 5.78 5.78 0 0 1-7.379 0"
  }))));
};
export default SvgNewcsDashboardTopbarNoticeIconNormal;